import { SET_PUBLIC_IP, LOG_OUT } from "../types";

const INITIAL_STATE = {
  ipv4: "",
  ipv6: ""
};

export default function publicIp(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case SET_PUBLIC_IP:
      return action.data;
    case LOG_OUT:
      return INITIAL_STATE;
    default:
      return state;
  }
}
